<template>
  <footer class="Footer_footer__2epqf" style="margin-top:96px">
    <div class="flex flex-col mx-auto max-w-4xl md:flex-row">
      <div style="display: flex; justify-content: space-around; flex: 1;align-items: center;">
<!--        <section>-->
<!--          <a href="/">Make Up Game</a>-->
<!--        </section>-->
        <section>
          <a href="/privacycheck">Privacy Policy</a>
        </section>
        <section>
          <a href="/termscheck">Terms of Use</a>
        </section>
        <section>
          <a href="mailto:fashiongame@gmail.com">Contact Us</a>
        </section>
      </div>
      <a class="flex items-center justify-center -mx-5 mt-8-1 py-5 border-t border-black md:order-first md:m-0 md:border-none"
         href="/"><img aria-hidden="true" alt="Fashion Make Up Game" class="hidden mr-3 rounded-2xl md:block"
                       height="80"
                       src="@/assets/img/bluebird/6.png" width="80">
        <div><h2 class="hidden text-white text-title-2 md:block">Make Up Game</h2><small
            class="text-white text-opacity-50 text-footnote">© 2019-2023 CUB &amp; PUP LLC</small></div>
      </a>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
